import CnilCompliance from './CnilCompliance';

export default CnilCompliance;
